import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import Wizard from '~/javascript/components/onboardings/wizard.vue'

export default class extends Controller {
  static values = {
    token: String
  }

  connect() {
    this.vue = createApp(Wizard, {
      mode: 'client',
      token: this.tokenValue
    })
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
